const configAggregator = (node) => {
    return {
        offsetTop: node.getAttribute('data-w-top-offset')
    }
}

export default configAggregator
